/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, November 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';

const tickStyle = {
  width: '1.5vw',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
};

const SingleDropDown = ({
  options,
  value,
  closeMenuOnSelect,
  placeholder,
  onChange,
  width,
}) => {

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: 'white',
      color: 'white',
      borderColor: state.isFocused ? 'gray' : 'gray',
      boxShadow: state.isFocused ? null : null,
      width: `${width}vw`,
      height: '5.25vh',
      minHeight: '5.25vh',
      borderRadius: '0vh',
      borderColor: '#a4a4a4',
      borderWidth: '0.1vh',
      '&:hover': {
        borderColor: state.isFocused ? 'gray' : 'gray'
      },
      overflow: 'scroll',
      fontSize: '2vh',
    }),
    valueContainer: (base, state) => ({
      ...base,
      padding: '0 0.2vw',
      color: 'red'
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '2vh',
      color: 'black',
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '2vh',
      padding: '0.6vh 1.3vw',
      backgroundColor: state.isSelected ? 'white' : 'white',
      color: state.isSelected ? 'black' : 'black',
      '&:hover': {
        backgroundColor: state.isSelected ? 'rgb(222, 235, 255)' : 'rgb(222, 235, 255)'
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '0px',
    }),
  };

  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div style={{ display: 'flex' }}>
          {props.isSelected
            ? <div style={tickStyle}> &#10003; </div>
            : <div style={tickStyle} />
          }
          <label>{props.label}</label>
        </div>
      </components.Option>
    );
  };

  return (
    <Select
      options={options}
      isMulti={false}
      value={value ? value : null}
      closeMenuOnSelect={closeMenuOnSelect}
      components={{ Option }}
      styles={customStyles}
      placeholder={placeholder}
      onChange={onChange}
      isSearchable={false}
    />
  );
};

export default SingleDropDown;

SingleDropDown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.object,
  closeMenuOnSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

SingleDropDown.defaultProps = {
  options: [],
  value: null,
  closeMenuOnSelect: false,
  placeholder: 'Please Select',
  onChange: () => { },
};
